import configureStore from './store';
const initiatedStore = configureStore();
export default initiatedStore;
